import { FETCHEXPENSE_SUCCESS, FETCHEXPENSE_FAIL } from '../actionTypes';

const initialState = {
    user: []
};

const fetchExpenseReducer = (state = initialState, action) => {
    switch (action.type) {
        case FETCHEXPENSE_SUCCESS:
            return {
                ...state,
                isLoggedIn: true,
                user: action.payload.user,
            };
        case FETCHEXPENSE_FAIL:
            return {
                ...state,
                isLoggedIn: false,
                user: [],
            };
        default:
            break;
    }

    return state;
};

export default fetchExpenseReducer;



